
(function(){
  /* ---------- intro overlay ---------- */
  var overlay=document.getElementById('fdaeIntroOverlay');
  if(overlay){
    if(overlay.parentNode!==document.body) document.body.appendChild(overlay); /* lift above any transformed Dawn ancestor */
    var video=document.getElementById('fdaeIntroVideo'), skip=document.getElementById('fdaeIntroSkip');
    var REVEAL_MS=900, INTRO_MS=4000;
    var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
    var timer=null, revealed=false;
    var hide=function(){overlay.classList.add('is-hidden');overlay.setAttribute('inert','');document.documentElement.style.overflow='';document.body.style.overflow='';};
    var reveal=function(){
      if(revealed)return; revealed=true;
      if(timer){clearTimeout(timer);timer=null;}
      try{ if(video) video.pause(); }catch(e){}
      if(rm){ hide(); return; }
      var done=false;
      var fin=function(e){ if(e&&e.propertyName&&e.propertyName!=='transform')return; if(done)return; done=true; overlay.removeEventListener('transitionend',fin); hide(); };
      overlay.addEventListener('transitionend',fin);
      setTimeout(fin,REVEAL_MS+150);
      requestAnimationFrame(function(){overlay.classList.add('is-up');});
    };
    if(rm){ reveal(); }
    else{
      document.documentElement.style.overflow='hidden'; document.body.style.overflow='hidden';
      timer=setTimeout(reveal,7000); /* absolute backstop if playback never starts */
      if(video){
        /* property-level muting: required for autoplay after the overlay is re-parented to <body> */
        video.muted=true; video.defaultMuted=true; video.setAttribute('muted','');
        video.addEventListener('ended',reveal,{once:true});
        /* once truly playing: let the FULL video run and swipe on 'ended' (duration cap = safety net only) */
        video.addEventListener('playing',function(){
          if(timer){clearTimeout(timer);timer=null;}
          var cap=(video.duration&&isFinite(video.duration))?Math.min(video.duration*1000+1500,15000):12000;
          timer=setTimeout(reveal,cap);
        },{once:true});
        /* the re-parent above interrupts the initial load: restart it cleanly, then play when actually ready */
        video.load();
        var tries=0;
        var tryPlay=function(){
          if(revealed) return;
          var p; try{ p=video.play(); }catch(e){ p=Promise.reject(e); }
          if(p&&p.catch)p.catch(function(err){
            if(revealed) return;
            if(err&&err.name==='NotAllowedError'){ reveal(); return; } /* true autoplay ban (e.g. Low Power Mode) */
            if(++tries<=4){ setTimeout(tryPlay,300*tries); } else { reveal(); }
          });
        };
        if(video.readyState>=2){ tryPlay(); } else { video.addEventListener('canplay',tryPlay,{once:true}); }
        /* second chance if a ready video is somehow still paused */
        setTimeout(function(){ if(!revealed&&video.paused&&video.readyState>=2){ tryPlay(); } },3500);
      }
      if(skip) skip.addEventListener('click',reveal);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') reveal(); });
    }
  }

  /* ---------- homepage behaviour (scoped to #fundae-home) ---------- */
  var root=document.getElementById('fundae-home'); if(!root) return;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fine=matchMedia('(hover:hover) and (pointer:fine)').matches;
  var $=function(s,c){return (c||root).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));};

  /* ===== PASTE YOUR MAILCHIMP FORM ACTION URL HERE to go live (empty = preview mode) =====
     Looks like: https://NAME.usXX.list-manage.com/subscribe/post?u=USERID&id=LISTID */
  var MAILCHIMP_ACTION="";

  /* entrance animations */
  function tag(sel,type){ $$(sel).forEach(function(el){el.setAttribute('data-reveal','');el.setAttribute('data-anim',type);}); }
  tag('.fdae-cozy','zoom'); tag('.fdae-col','pop'); tag('.fdae-perk','flip'); tag('.fdae-story .fdae-tile','rise');
  var msg=$('.fdae-tile.fdae-msg'); if(msg) msg.setAttribute('data-anim','zoom');
  var bandHead=$('.fdae-band h2'); if(bandHead){var w=bandHead.closest('[data-reveal]'); if(w) w.setAttribute('data-anim','left');}
  var cap=$('#fdae-capture'); if(cap) cap.setAttribute('data-anim','right');
  var bstar=$('.fdae-band .fdae-star'); if(bstar) bstar.setAttribute('data-anim','pop');
  $$('.fdae-collections,.fdae-why-grid,.fdae-story,.fdae-story-foot,.fdae-hero-copy').forEach(function(g){
    Array.prototype.slice.call(g.querySelectorAll('[data-reveal]')).forEach(function(el,i){el.style.setProperty('--d',(i*90)+'ms');});
  });

  /* reveal-on-scroll */
  var cozyEl=$('.fdae-cozy');
  var io=new IntersectionObserver(function(es){es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); if(en.target===cozyEl){setTimeout(function(){cozyEl.style.transition='transform .25s ease';},900);} io.unobserve(en.target);} });},{threshold:.12,rootMargin:'0px 0px -50px 0px'});
  $$('[data-reveal]').forEach(function(el){io.observe(el);});

  /* email capture + confetti */
  var form=$('#fdae-capture'), success=$('#fdae-success');
  function burst(x,y){ if(reduce)return; var em=['💗','⭐','💙','🍒','✨']; for(var i=0;i<18;i++){ (function(){ var s=document.createElement('div');s.className='fdae-confetti';s.textContent=em[i%em.length];s.style.left=x+'px';s.style.top=y+'px';s.style.setProperty('--tx',(Math.random()*260-130)+'px');s.style.setProperty('--r',(Math.random()*360-180)+'deg');s.style.animationDelay=(Math.random()*.12)+'s';document.body.appendChild(s);setTimeout(function(){s.remove();},1450); })(); } }
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var fn=form.first_name.value.trim(), emv=form.email.value.trim();
      if(!fn || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emv)){form.reportValidity();return;}
      var btn=form.querySelector('button'); btn.textContent='Adding you…';
      var showSuccess=function(){ var r=btn.getBoundingClientRect(); burst(r.left+r.width/2,r.top+r.height/2); $$('input,select,button,.fdae-form-note',form).forEach(function(el){el.style.display='none';}); success.style.display='block'; };
      if(!/list-manage\.com/.test(MAILCHIMP_ACTION)){ console.warn('[FUNDAE] PREVIEW MODE - MAILCHIMP_ACTION empty; signup NOT captured.'); showSuccess(); return; }
      var params=new URLSearchParams({EMAIL:emv,FNAME:fn,MMERGE3:form.sport.value});
      var cb='mc_cb_'+Date.now(); window[cb]=function(){ try{delete window[cb];}catch(_){} showSuccess(); };
      var sc=document.createElement('script'); sc.src=MAILCHIMP_ACTION.replace('/post?','/post-json?')+'&'+params.toString()+'&c='+cb;
      sc.onerror=function(){ try{delete window[cb];}catch(_){} showSuccess(); }; document.body.appendChild(sc);
    });
  }

  /* ambient sparkles */
  var sky=$('.fdae-sky');
  var shapes=[
    '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="#f5a9cf"><path d="M12 20s-7-4.3-7-9.3A3.7 3.7 0 0 1 12 8a3.7 3.7 0 0 1 7 2.7c0 5-7 9.3-7 9.3z"/></svg>',
    '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="#a9cef0"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>',
    '<svg width="100%" height="100%" viewBox="0 0 24 24" fill="#f7c0dc"><path d="M12 2v20M2 12h20M5 5l14 14M19 5 5 19"/></svg>'
  ];
  if(sky && !reduce){ var n=fine?14:7; for(var i=0;i<n;i++){ var d=document.createElement('div'); d.className='fdae-drift'; var sz=8+Math.random()*16; d.style.left=Math.random()*100+'%'; d.style.width=sz+'px'; d.style.height=sz+'px'; d.style.animationDuration=(14+Math.random()*16)+'s'; d.style.animationDelay=(-Math.random()*20)+'s'; d.innerHTML=shapes[i%shapes.length]; sky.appendChild(d); } }

  /* desktop pointer flourishes */
  if(fine && !reduce){
    $$('.fdae-btn').forEach(function(b){ b.addEventListener('pointermove',function(e){var r=b.getBoundingClientRect();b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.18)+'px,'+((e.clientY-r.top-r.height/2)*.3)+'px)';}); b.addEventListener('pointerleave',function(){b.style.transform='';}); });
    if(cozyEl){ cozyEl.addEventListener('pointermove',function(e){var r=cozyEl.getBoundingClientRect();var rx=((e.clientY-r.top)/r.height-.5)*-7;var ry=((e.clientX-r.left)/r.width-.5)*7;cozyEl.style.transform='perspective(900px) rotateX('+rx+'deg) rotateY('+ry+'deg)';}); cozyEl.addEventListener('pointerleave',function(){cozyEl.style.transform='';}); }
    if(sky){ addEventListener('pointermove',function(e){var mx=(e.clientX/innerWidth-.5),my=(e.clientY/innerHeight-.5);sky.style.transform='translate('+(mx*16)+'px,'+(my*16)+'px)';},{passive:true}); }
  }

  /* pom + hero + background scroll parallax (rAF-throttled; translate vars
     compose with the pointer-tilt transform so they never fight) */
  var pom=$('.fdae-pom'), heroSec=$('.fdae-hero');
  if(!reduce){
    var parTick=false;
    var onPar=function(){
      parTick=false;
      var y=scrollY;
      if(pom) pom.style.transform='translateY('+(-y*.06)+'px)';
      if(cozyEl && heroSec){
        var hh=heroSec.offsetHeight||1;
        var p=Math.min(1,y/hh);
        cozyEl.style.setProperty('--fdaePar',(p*-46)+'px');
      }
      root.style.setProperty('--fdaeParBg',(y*.045)+'px');
    };
    addEventListener('scroll',function(){ if(!parTick){parTick=true;requestAnimationFrame(onPar);} },{passive:true});
    onPar();
  }

  /* twinkling doodles */
  var dood={
    heart:'<svg viewBox="0 0 24 24" fill="#f48fbe"><path d="M12 21s-8-4.7-8-10.6A4.4 4.4 0 0 1 12 8a4.4 4.4 0 0 1 8 2.4C20 16.3 12 21 12 21z"/></svg>',
    star:'<svg viewBox="0 0 24 24" fill="#5a9be0"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>',
    spark:'<svg viewBox="0 0 24 24" fill="#ec5fa3"><path d="M12 2c.6 4.9 2.4 6.7 7.3 7.3C14.4 9.9 12.6 11.7 12 16.6 11.4 11.7 9.6 9.9 4.7 9.3 9.6 8.7 11.4 6.9 12 2z"/></svg>'
  };
  function addDoodle(parent,type,css){var d=document.createElement('div');d.className='fdae-doodle';d.style.cssText=css;d.innerHTML=dood[type];d.style.animationDelay=(Math.random()*2.5)+'s';parent.appendChild(d);}
  var heroEl=$('.fdae-hero');
  if(heroEl && innerWidth>600){ addDoodle(heroEl,'spark','left:43%;top:7%;width:30px'); addDoodle(heroEl,'heart','left:38%;top:45%;width:30px'); addDoodle(heroEl,'star','left:1.5%;top:60%;width:22px'); addDoodle(heroEl,'spark','left:50%;top:73%;width:22px'); }
  $$('.fdae-head').forEach(function(h,i){ addDoodle(h,i%2?'heart':'star',(i%2?'right:4%;':'left:4%;')+'top:-10px;width:26px'); });
})();
